export default {
    collapsedMenu(state) {
        return state.collapsed
    },
    getAuth(state, getters, rootState) {
        console.log('state', rootState)
    }

}
